module.exports = __webpack_public_path__ + "static/media/ethical-hacking.01680291.png";